import {
  SET_SHOW_PUBLISH,
  SET_IS_CART,
  SET_ORDER_OBJ,
  SET_TALKBAO_INDEX,
  SET_IMPRINT_INDEX,
  SET_SHOW_UPDATENUM,
  SET_FOCUS_ADDREMARK,
  SET_USER_INFO,
  SET_BOOTHSTORE_DETAIL,
  SET_ORDER_KEYID,
  SET_templateLibraryId,
  SET_IGET_SALESNUM,
  SET_IGET_UPDATESALESNUM,
  SET_BACK_WAITORDER,
  SET_ADD_REMARKTEXT,
  SET_ADD_REMARKOBJ,
  SET_VIDEO_SHOW,
  SET_VIDEO_SRC,
  SET_Home_POP,
  SET_PASSWORD_STATUS,
  SET_STORE_ID,
  SET_NFC_READTXT,
  SET_NFC_WRITETXT,
  SET_WRITE_STATE,
  SET_LAST_CHIP_UID,
  SET_REDIRECT_TO,
  SET_USER_GEO,
  CLEAR_REDIRECT_TO, SET_USER_ID
} from './mutations-type'

/**
 * 📌 作用：唯一可以直接修改 state 的地方，必须是同步的
 * ✅ 如何使用 mutations 修改 state？
 * this.$store.commit('SET_USER_ID', 12345);
 */
export default {
  //新增或者已整理的
  [SET_USER_ID](state, data) {
    state.userId = Number(data); // 确保 userId 是数字类型
    localStorage.setItem('userId', state.userId); // 存入 localStorage
  },

  //未整理的

  updateTabActive(state, active) {
    state.active = active
  },
  setHintVisible(state, visible) {
    state.hintVisible = visible;
  },
  [SET_SHOW_PUBLISH](state, data) {
    state.showPublish = data;
  },
  [SET_IS_CART](state, data) {
    state.isCart = data;
  },
  [SET_ORDER_OBJ](state, data) {
    state.orderStateObj = data;
  },
  [SET_TALKBAO_INDEX](state, data) {
    state.talkbaoindex = data;
  },
  [SET_IMPRINT_INDEX](state, data) {
    state.imprintindex = data;
  },
  [SET_SHOW_UPDATENUM](state, data) {
    state.showUpdateNum = data;
  },
  [SET_FOCUS_ADDREMARK](state, data) {
    state.focusAddRemark = data;
  },
  //用户id
  [SET_USER_INFO](state, data) {
    localStorage.setItem('id', JSON.stringify(data))
    state.id = data;
  },
  //展台店铺详情
  [SET_BOOTHSTORE_DETAIL](state, data) {
    state.boothStoreDetail = data;
  },
  //订单主键ID
  [SET_ORDER_KEYID](state, data) {
    state.orderKeyId = data;
  },
  // 选择模板id
  [SET_templateLibraryId](state, data) {
    state.templateLibraryId = data;
  },
  // 我抢到的弹出框文本
  [SET_IGET_SALESNUM](state, data) {
    state.iGetSalesNum = data;
  },
  [SET_IGET_UPDATESALESNUM](state, data) {
    state.iGetUpdateSalesNum = data;
  },
  [SET_BACK_WAITORDER](state, data) {
    state.backWaitOrder = data;
  },
  [SET_ADD_REMARKTEXT](state, data) {
    state.addRemarkText = data;
  },
  [SET_ADD_REMARKOBJ](state, data) {
    state.addRemarkObj = data;
  },
  [SET_VIDEO_SHOW](state, data) {
    state.videoShow = data;
  },
  [SET_VIDEO_SRC](state, data) {
    state.videoSrc = data;
  },
  [SET_Home_POP](state, data) {
    state.homePop = data;
  },
  [SET_PASSWORD_STATUS](state, data) {
    state.passwordStatus = data
  },
  // 店铺id
  [SET_STORE_ID](state, data) {
    state.storeId = data
  },
  //nfc
  setNfcReadTxt(state, data) {
    state.nfcReadTxt = data
  },
  //setNfcWriteTxt
  setNfcWriteTxt(state, data) {
    state.nfcWriteTxt = data
  },
  [SET_NFC_READTXT](state, data) {
    state.nfcReadTxt = data
  },
  [SET_NFC_WRITETXT](state, data) {
    state.nfcWriteTxt = data
  },
  [SET_WRITE_STATE](state, data) {
    state.isWriteState = data
  },
  setUserGeo(state, data) {
    state.userGeo = data
  },
  [SET_USER_GEO](state, data) {
    state.userGeo = data
  },
  setLastChipUid(state, data) {
    state.lastChipUid = data
  },

  [SET_LAST_CHIP_UID](state, data) {
    state.lastChipUid = data
  },

//NFC
  SET_READ_MODE(state, status) {
    state.readMode = status;
  },
  SET_WRITE_MODE(state, status) {
    state.writeMode = status;
  },
  SET_PROCESSING(state, status) {
    state.isProcessing = status;
  },
  SET_MULTIPLE_WRITE(state, status) {
    state.multipleWrite = status;
  },

  SET_RESOURCE_ID(state, resourceId) {
    state.resourceId = resourceId;
    localStorage.setItem('resourceId', resourceId); // 同步到 localStorage
  },

  [SET_REDIRECT_TO](state, route) {
    state.redirectTo = route;
  },
  [CLEAR_REDIRECT_TO](state) {
    state.redirectTo = null;
  },

  // 保存当前页面 URL
  setRedirectTo(state, { path, query, params }) {
    state.redirectTo = { path, query, params };
  },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js